import { render, staticRenderFns } from "./CardChart.vue?vue&type=template&id=506ebe98"
import script from "./CardChart.vue?vue&type=script&lang=js"
export * from "./CardChart.vue?vue&type=script&lang=js"
import style0 from "./CardChart.vue?vue&type=style&index=0&id=506ebe98&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('506ebe98')) {
      api.createRecord('506ebe98', component.options)
    } else {
      api.reload('506ebe98', component.options)
    }
    module.hot.accept("./CardChart.vue?vue&type=template&id=506ebe98", function () {
      api.rerender('506ebe98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/emc/base/CardChart.vue"
export default component.exports